import { Box, Button, Container, Grid, MobileStepper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import moment from "moment";
import { IResultRegRecbRecibos } from "../../../../../../../../types/mutations/financeiro/registrar-recebimento-titulos";
import BtnImprimirRecibo from "../../../../../MostarRecibo/BtnImprimirRecibo";
import BtnCompartilhar from "../../../../../../../../components/BtnCompartilhar";
import { formatarValorMonetario } from "../../../../../../../../helpers/masks";
import { useModalDetalheTituloPagar } from "../../../../ModalDetalheTituloContext";

export default function PagamentoRegistrado({
    temRecibo = true
}: PagamentoRegistradoProps) {

    const { watch } = useFormContext();
    const { openModal } = useModalDetalheTituloPagar();

    const pagamentoRegistrado: IResultRegPagamento = watch('pagamentoRegistrado')
    const maxSteps = pagamentoRegistrado.recibos ? pagamentoRegistrado.recibos.length : 0
    const numRecibo = pagamentoRegistrado.recibos ? pagamentoRegistrado.recibos[0].recibo : 0
    const [activeStep, setActiveStep] = useState(0);

    //funções manipuladoras
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    //

    return (
        <Container maxWidth="sm">
            <Grid container spacing={2} my={3} sx={{ minHeight: 300 }}>
                <Grid container size={{xs: 12}}>
                    <Grid size={{xs: 3}}>
                        <img src="/imgs/img-comprovante.png" alt="img" width={91} />
                    </Grid>

                    <Grid size={{xs: 9}}>
                        <Box display="flex" flexDirection="column" justifyContent="flex-end">
                            <Typography variant="h4">Pagamento registrado</Typography>
                            <Typography variant="subtitle1">{moment(pagamentoRegistrado.data_hora).format('DD/MM/YYYY HH:mm')}</Typography>
                        </Box>
                    </Grid>
                </Grid>

                {
                    pagamentoRegistrado.movimentacoes && pagamentoRegistrado.movimentacoes.length > 0 &&
                    <Grid container size={{xs: 12}}>
                        <TableContainer>
                            <Table size="small" aria-label="tabela simples">
                                <TableHead>
                                    <TableRow>
                                        {headers.map((header, index) => (
                                            <TableCell
                                                key={index}
                                                align={header.numeric ? "right" : "left"}
                                            >
                                                <b>{header.label}</b>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {pagamentoRegistrado.movimentacoes.map((row, index) => (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell>
                                                <Link onClick={() => openModal(row.titulo)} sx={{ cursor: 'pointer' }}>{row.titulo}</Link>
                                            </TableCell>
                                            <TableCell align="right">
                                                {formatarValorMonetario(row.valor_pago)}
                                            </TableCell>

                                        </TableRow>
                                    ))}


                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            <b>Total</b>
                                        </TableCell>
                                        <TableCell align="right">
                                            <b>{formatarValorMonetario(pagamentoRegistrado.movimentacoes.reduce((total, row) => total + row.valor_pago, 0))}</b>
                                        </TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                }

                {
                    pagamentoRegistrado.recibos &&
                    pagamentoRegistrado.recibos.length > 0 &&
                    pagamentoRegistrado.recibos.map((item, index: number) => {
                        if (index !== activeStep) return (<></>)

                        return (
                            <Grid key={index} container size={{xs: 12}} spacing={2} columnSpacing={20}>
                                <Grid size={{xs: 12, md: 5}}>
                                    <LabelRecibo
                                        titulo={'Valor pago'}
                                        valor={item.valor ? formatarValorMonetario(item.valor) : "-"}
                                    />
                                </Grid>
                                {
                                    temRecibo &&
                                    <Grid size={{xs: 12, md: 7}}>
                                        <LabelRecibo
                                            titulo="Forma"
                                            valor={item.forma_recebimento}
                                        />
                                    </Grid>
                                }

                                <Grid size={{xs: 12, md: temRecibo ? 5 : 7}}>
                                    <LabelRecibo
                                        titulo={"Pago por"}
                                        valor={pagamentoRegistrado.recebido_por}
                                    />
                                </Grid>
                                {
                                    temRecibo &&
                                    <Grid size={{xs: 12, md: 7}}>
                                        <LabelRecibo
                                            titulo="Comprovante"
                                            valor={item.recibo.toString()}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        )
                    })
                }
            </Grid>

            {
                maxSteps > 1 &&
                <MobileStepper
                    steps={maxSteps}
                    position="static"
                    activeStep={activeStep}
                    color='success'
                    nextButton={
                        <Button color='success'
                            size="small"
                            onClick={handleNext}
                            disabled={activeStep === maxSteps - 1}
                        >
                            <KeyboardArrowRight />
                        </Button>
                    }
                    backButton={
                        <Button
                            color='success'
                            size="small"
                            onClick={handleBack}
                            disabled={activeStep === 0}
                        >
                            <KeyboardArrowLeft />
                        </Button>
                    }
                    sx={{
                        px: 0,
                        bgcolor: "transparent"
                    }}
                />
            }

            {
                temRecibo &&
                <Box display="flex" justifyContent="center" alignItems="center" gap={1} mt={2}>
                    <BtnImprimirRecibo {...{ numRecibo }} />
                    <BtnCompartilhar
                        mensagem={'mensagem'}
                        meio={['email']}
                        recibo={numRecibo}
                    />
                </Box>
            }
        </Container>
    )
}

const headers = [
    { label: "Título" },
    { label: "Valor", numeric: true }
]

interface PagamentoRegistradoProps {
    temRecibo?: boolean
}

export interface IResultRegPagamento {
    recebido_por: string,
    data_hora: string,
    recibos?: Array<IResultRegRecbRecibos>
    movimentacoes?: Array<TPagamentosMovimentacoes>
}

type TPagamentosMovimentacoes = {
    titulo: string;
    valor_pago: number;
}

function LabelRecibo({
    titulo,
    valor
}: { titulo: string, valor: string }) {
    return (
        <Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Typography variant="body1">
                    {titulo}
                </Typography>
            </Box>
            <Box display="flex" gap={1}>
                <Typography variant="h5" fontWeight="bold">
                    {valor}
                </Typography>
            </Box>
        </Box>
    )
}